var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 6.87891H4L4 8.21224H2.66667L2.66667 6.87891ZM12 3.54557L12 12.8789C12 13.6122 11.4 14.2122 10.6667 14.2122L1.33333 14.2122C0.593333 14.2122 0 13.6122 0 12.8789L0.00666666 3.54557C0.00666666 2.81224 0.593333 2.21224 1.33333 2.21224L2 2.21224L2 0.878906L3.33333 0.878906L3.33333 2.21224L8.66667 2.21224V0.878906L10 0.878906V2.21224H10.6667C11.4 2.21224 12 2.81224 12 3.54557ZM1.33333 4.87891L10.6667 4.87891L10.6667 3.54557L1.33333 3.54557L1.33333 4.87891ZM10.6667 12.8789L10.6667 6.21224L1.33333 6.21224L1.33333 12.8789L10.6667 12.8789ZM8 8.21224L9.33333 8.21224V6.87891L8 6.87891V8.21224ZM5.33333 8.21224L6.66667 8.21224V6.87891L5.33333 6.87891V8.21224Z",
    fill: "#42495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.9bfdc95c.svg";
export { ForwardRef as ReactComponent };